import { createSelector } from '@ngrx/store';
import * as _ from 'lodash';
import { PayrollRuleEntry } from 'app/api/payroll.rule.api.service';
import { PayrollEntryByName } from 'app/api/payroll.api.service';
import {
  selectPayrollAna2View,
} from './payroll.analytics.selectors';

export const selectPayrollAna2WithoutNA = (
  payrolls: PayrollEntryByName[],
  rules: PayrollRuleEntry[]
) =>
  createSelector(selectPayrollAna2View(payrolls, rules), (axisMap) =>
    Object.values(axisMap)
  );
